var map = {
	"./base/Button.vue": "d084",
	"./base/Image.vue": "eb4a",
	"./base/ImageZoom.vue": "6a15",
	"./base/Images.vue": "dc14",
	"./base/Link.vue": "9689",
	"./base/Links.vue": "4309",
	"./base/Sections.vue": "caaa",
	"./base/Spinner.vue": "f34e",
	"./base/Svg.vue": "5b17",
	"./base/Text.vue": "b9e7",
	"./base/Video.vue": "ead9",
	"./layout/Col.vue": "d74b",
	"./layout/Container.vue": "e6fe",
	"./layout/Row.vue": "d28c",
	"./layout/Segment.vue": "873e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b37e";